export const EDITOR_DEFAULT_CONTENT = [
  { type: 'title', children: [{ text: '' }] },
]
